export const ALL_BROWSERS = [{
  code: 'and_chr',
  fullName: 'Chrome (Android)',
  isMobile: true
}, {
  code: 'and_ff',
  fullName: 'Firefox (Android)',
  isMobile: true
}, {
  code: 'and_qq',
  fullName: 'QQ browser (Android)',
  isMobile: true
}, {
  code: 'and_uc',
  fullName: 'UC Browser (Android)',
  isMobile: true
}, {
  code: 'android',
  fullName: 'Android browser',
  isMobile: true
}, {
  code: 'baidu',
  fullName: 'Baidu Browser',
  isMobile: false
}, {
  code: 'bb',
  fullName: 'BlackBerry Browser',
  isMobile: true
}, {
  code: 'chrome',
  fullName: 'Google Chrome',
  isMobile: false
}, {
  code: 'edge',
  fullName: 'Microsoft Edge',
  isMobile: false
}, {
  code: 'firefox',
  fullName: 'Firefox',
  isMobile: false
}, {
  code: 'ie',
  fullName: 'Internet Explorer',
  isMobile: false
}, {
  code: 'ie_mob',
  fullName: 'Internet Explorer (mobile)',
  isMobile: true
}, {
  code: 'ios_saf',
  fullName: 'Safari (iOS)',
  isMobile: true
}, {
  code: 'kaios',
  fullName: 'KaiOS browser',
  isMobile: false
}, {
  code: 'op_mob',
  fullName: 'Opera Mobile',
  isMobile: true
}, {
  code: 'op_mini',
  fullName: 'Opera Mini',
  isMobile: true
}, {
  code: 'opera',
  fullName: 'Opera',
  isMobile: false
}, {
  code: 'safari',
  fullName: 'Safari',
  isMobile: false
}, {
  code: 'samsung',
  fullName: 'Samsung Internet Browser',
  isMobile: true
}];
export const CHARACTER_SET = 'utf8';
export const AUTOGENERATED_FILE_HEADER = `/*
  THIS IS AN AUTOGENERATED FILE. DO NOT EDIT IT.
  If you want to regenerate it, run one of the following commands:

    yarn start
    yarn build
*/
`;
export const ASSET_FILENAME_SEPARATOR = '_';
export const SCOPE_NAME = '@mbank-design';
export const SCOPE_NAME_ALIASED = '@mbank-design';
export const PACKAGE_NAME = 'design-system';
export const GLOBAL_CSS_BUILD_DIRECTORY = 'build/global-styles';
export const GLOBAL_WEB_COMPONENTS_CSS_FILE = '../web-components/globals.css';
export const CONSTANT_WEB_COMPONENTS_STYLES_FILE = '../web-components/styles.css';
export const COMPONENTS_LIBRARY_CSS_ASSETS_DIR = 'styleguidist/assets/css';
export const GLOBAL_STYLES_STYLESHEET_PREFIX = 'global';
export const ALL_SVG_ASSETS_INDEX_FILENAME = 'index.js';
export const ICONS_DIR_NAME = 'src/icons';
export const SYMBOLS_DIR_NAME = 'src/symbols';
export const AssetType = {
  ANIMATIONS: 'animations',
  AVATARS: 'avatars',
  ICONS: 'icons',
  FLAGS: 'flags',
  ILLUSTRATIONS: 'illustrations',
  LOGOS: 'logos',
  SYMBOLS: 'symbols'
};
export const ACCEPTED_ASSET_FILE_EXTENSIONS = new Set(['.svg', '.eot', '.ttf', '.woff', '.woff2']);
export const LIBRARY_SRC_DIRECTORY = 'src';
export const STYLEGUIDIST_ASSETS_DIRECTORY = 'styleguidist/assets';
export const CONTROL_FILENAME = '.assets_generated';
export const PRETTIER_BUILD_MODULE_DIRECTORY = 'prettier-config';
export const PRETTIER_CONFIG_FILENAME = 'prettier.config.cjs';
export const ESLINT_BUILD_MODULE_DIRECTORY = 'eslint-config';
export const ESLINT_CONFIG_FILENAME = 'eslint-config/index.js';
export const COMPONENT_CLASS_NAME_PREFIX = 'design'.charAt(0) + 'system'.charAt(0);
export const DESIGN_SYSTEM_FIXED_POSITION_CLASS_NAME = 'design-system-fixed-position';
export const EXCLUDED_CODEMODS_DIRECTORIES = new Set(['__tests__', '__testfixtures__', 'README.md']);
export const BASE_STYLEGUIDE_URL = 'https://mbank.design/';
export const FONTS_CSS_FILE = 'fonts.css';
export const FONTS_30_CSS_FILE = 'fonts_30.css';
export const DESIGN_SYSTEM_NAME = 'mBank design system';
export const DEFAULT_THEME_NAME = 'mBank';
export const DARK_THEME_NAME = 'mBank Dark';
export const THEME_NAME_DARK_SUFFIX = 'Dark';
export const DARK_THEME_ASSET_SUFFIX = '_dark_theme';
export const DESIGN_SYSTEM_VERSION_CSS_VARIABLE_NAME = 'design-system-version';
export const ICON_DOWNLOAD_FORMATS = ['svg', 'png1', 'png4', 'eps', 'pdf', 'xml'];
export const ILLUSTRATION_DOWNLOAD_FORMATS = ['svg', 'png1', 'png4', 'eps', 'pdf', 'xml'];
export const LOGO_DOWNLOAD_FORMATS = ['svg', 'png1', 'png4', 'eps', 'pdf', 'xml'];
export const FLAG_DOWNLOAD_FORMATS = ['svg', 'png1', 'png4', 'eps', 'pdf', 'xml'];
export const SYMBOL_DOWNLOAD_FORMATS = ['svg', 'png1', 'png4', 'eps', 'pdf', 'xml'];
export const ZIP_DOWNLOAD_FORMATS = ['svg', 'png', 'eps', 'pdf', 'xml'];